import AccountingCoordinator from "../../shared/documentInfrastructure/AccountingCoordinator.js";

/**
 * Model holding all the parts of a comparison tool document, its
 * widgets and its state. It handles communication between all of
 * these by registering to events and dispatching them via message
 * sends.
 */
export default class ComparisonToolDocumentCoordinator extends AccountingCoordinator {
	onCurrentPeriodChanged({ period }) {
		this._documentState
			.onPeriodChange(period)
			.then(() => this._onContentChange());
	}

	wantsActions() {
		return true;
	}

	hasPeriodPicker() {
		return false;
	}

	_setupDocumentStateCallbacks() {
		return {
			onContentUpdateRequest: () => this._onContentChange(),
		};
	}

	_onContentChange() {
		this._content.update();
		this._actions.update();
	}
}
